import React from 'react'
import { resolvePrismicLink } from '../../../utils/prismicLinkResolver'
import usePageContext from '../../../hooks/usePageContext'
import CtaSection from '../../sections/CtaSection'
import { CTASliceProps } from './types'
import { mapButtonProps } from '../../atoms/Button/utils'

const CTASlice: React.FC<CTASliceProps> = ({ slice }) => {
  const {
    cta_title,
    cta_description,
    cta_link,
    cta_link_type,
    cta_link_text,
    cta_link_is_centered,
    cta_link_caption,
    cta_link_caption_mobile_size,
    cta_link_caption_desktop_size
  } = slice.primary || {}
  const { group } = usePageContext()

  return (
    <CtaSection
      inner="inners.primary"
      paddingTop={['20px', '', '70px']}
      paddingBottom={['20px', '', '70px']}
      data={{
        title: cta_title?.text,
        subtitle: cta_description?.text,
        cta: mapButtonProps(
          cta_link_type,
          cta_link_text,
          resolvePrismicLink(cta_link, group),
          cta_link?.link_type,
          cta_link_caption,
          cta_link_caption_mobile_size,
          cta_link_caption_desktop_size,
          cta_link_is_centered
        )
      }}
    />
  )
}

export default CTASlice
